import React from 'react';
import { FaFacebookF, FaInstagram, FaMapMarkerAlt } from 'react-icons/fa';
import { HiOutlineMail } from 'react-icons/hi';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const location = useLocation();
  const isContactPage = location.pathname === '/contact';

  return (
    <>
      <footer className="footer-section">
        <div className="footer-grid">
          {/* Logo & About */}
          <div>
            <img src="/logo.png" alt="Sonal Holidays" className="footer-logo" />
            <p className="footer-about">
              Sonal Holidays curates month-based, mood-specific holidays for every kind of traveler.
              Whether it's beach bliss in January or snow-capped adventures in December, we craft every detail so you don’t have to.
            </p>
            <div className="footer-socials">
              <a href="https://www.instagram.com/sonalholidays" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/share/15qWMGQy5D/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="footer-title">Get In Touch</h4>
            <div className="footer-contact">
              <p className="footer-contact-icon"><FaMapMarkerAlt /> 708, Shubham Avenue, Pant Nagar, Ghatkopar (E), Mumbai - 400075</p><br />
              <p className="footer-contact-icon"><FaMapMarkerAlt /> Welfare chambers, Shop No 17, Plot No 73, Sector -17, Vashi, Navi Mumbai - 400703</p><br />
              <p className="footer-contact-icon"><FaMapMarkerAlt /> F-16, Speranza Business Hub-B, Next To Raj Victoria, Adajan-Pal Road, Surat - 395009</p><br />
              <p className="footer-contact-icon">
                <i className="fa-solid fa-phone"></i>
                <a href="tel:+919773749023" target="_blank" rel="noopener noreferrer"> +91 97737 49023</a>
              </p><br />
              <p className="footer-contact-icon">
                <HiOutlineMail />
                <a href="mailto:khyati@sonalholidays.com" target="_blank" rel="noopener noreferrer"> khyati@sonalholidays.com</a>
              </p>
            </div>
          </div>

          {/* Useful Links */}
          <div>
            <h4 className="footer-title">Useful Link</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li><br />
              <li><Link to="/about-us">About Us</Link></li><br />
              <li><Link to="/PopularDestinations">Our Destinations</Link></li><br />
              <li><Link to="/contact">Contact Us</Link></li><br />
            </ul>
          </div>

          {/* Instagram Posts – Hidden on Contact Page */}
          {!isContactPage && (
            <div className="footer-instagram-wrapper">
              <h4 className="footer-title">Instagram Post</h4>
              <div className="footer-instagram">
                {[
                  "https://www.instagram.com/reel/DJO7_Blya4-/",
                  "https://www.instagram.com/reel/DDKKEa0SwSf/",
                  "https://www.instagram.com/p/DIWSsxzy4yR/",
                  "https://www.instagram.com/reel/DD9g8uuSV_o/"
                ].map((url, i) => (
                  <div className="footer-insta-post" key={i}>
                    <iframe
                      src={`${url}embed`}
                      title={`Instagram Footer ${i}`}
                      className="footer-insta-embed"
                      frameBorder="0"
                      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                      allowFullScreen
                    ></iframe>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </footer>

      <div className="footer-bottom-bar">
        <p>Copyright © 2024 Sonal Holidays, All rights reserved.</p>
      </div>
    </>
  );
}

export default Footer;
